const FRONT_CHAT_SHOW_RETRY_MS = 250;
const FRONT_CHAT_SHOW_MAX_ATTEMPTS = 8;

function runWhenFrontChatReady(run: () => void): void {
  if (typeof window === "undefined") {
    return;
  }

  let attempts = 0;

  const tryRun = () => {
    attempts += 1;
    if (window.FrontChat) {
      run();
      return;
    }
    if (attempts < FRONT_CHAT_SHOW_MAX_ATTEMPTS) {
      window.setTimeout(tryRun, FRONT_CHAT_SHOW_RETRY_MS);
    }
  };

  tryRun();
}

/**
 * Opens the Front support chat panel. Retries briefly because Front's `show`
 * command can no-op if called before init completes (see FrontChat.tsx).
 */
export function openFrontChat(): void {
  runWhenFrontChatReady(() => {
    window.FrontChat("show");
  });
}

/** Closes the Front support chat panel (launcher remains when enabled). */
export function hideFrontChat(): void {
  runWhenFrontChatReady(() => {
    window.FrontChat("hide");
  });
}

export type FrontChatVisibilityState = {
  is_window_visible?: number;
};

/**
 * Registers a Front visibility listener after init. Returns cleanup when the
 * SDK supports `onWindowVisibilityChanged`.
 */
export function subscribeFrontChatVisibility(
  handler: (state: FrontChatVisibilityState) => void
): () => void {
  if (typeof window === "undefined" || !window.FrontChat) {
    return () => undefined;
  }

  const unbind = window.FrontChat("onWindowVisibilityChanged", handler);
  return typeof unbind === "function" ? unbind : () => undefined;
}
